/**
 * What the bank's overlays that slide in over the page share: MUI
 * SwipeableDrawers, the sidebar on a phone (BankSidebarDrawer) and the
 * phone's bottom sheets (BankBottomSheet: the filters and the AI panel). One
 * definition, so they stay alike and at the same level.
 */

/**
 * Whether the page runs on iOS, read once at load as MUI's SwipeableDrawer
 * reads it. MUI's advice for that drawer: only iOS devices fade the backdrop
 * along with a swipe without dropping frames, so the overlays keep the
 * backdrop transition there only. Its other iOS advice, `disableDiscovery`,
 * does nothing in MUI 4: the peek it turns off belongs to swipe-to-open,
 * which MUI already leaves off on iOS (that swipe is Safari's Back).
 */
export const IS_IOS =
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

/**
 * z-index of the overlays: above the app bar (drawer + 1) and under the
 * dialogs whatever order their portals were made in, since at the dialogs'
 * own level the later portal would paint on top.
 * @param {Object} theme MUI theme
 * @returns {number}
 */
export const getBankOverlayZIndex = (theme) => theme.zIndex.drawer + 2;
